<div class="list-popup">
  <app-cx-builder [selectionType]="'copy'" [copyType]="'message'" [includeSmsOnlyMessages]="includeSmsOnlyMessages"></app-cx-builder>
</div>
